import { PayloadAction } from "@reduxjs/toolkit";
import { GetEmployeeResponse } from "../../../../../services/reddyApi/Employees/Employees.response";
import { EmployeesState } from "../../models/EmployeesState";
import { GetEmployeeSuccessPayload } from "../../payload/GetEmployee/GetEmployeeSuccessPayload";

const getEmployeeSuccess = (state: EmployeesState, action: PayloadAction<GetEmployeeSuccessPayload>) => {

}

export default getEmployeeSuccess;